import React from 'react';
import { Car, Wrench, Maximize, DoorOpen, ShieldAlert, Truck } from 'lucide-react';
export function Services() {
  const services = [{
    title: 'Windshield Replacement',
    copy: 'Fast windshield replacement for foreign and domestic cars, trucks, vans and SUVs, with quality glass options and certified installation.',
    icon: <Car className="w-6 h-6 text-brand-blue" data-id="element-389" />
  }, {
    title: 'Windshield Chip Repair',
    copy: "Small stone chips may be repairable before they spread. Kosin's Glass can inspect the damage and recommend repair or replacement.",
    icon: <Wrench className="w-6 h-6 text-brand-blue" data-id="element-390" />
  }, {
    title: 'Side Window Replacement',
    copy: 'Driver and passenger side window replacement, power window glass and quarter glass for cars, trucks and SUVs.',
    icon: <Maximize className="w-6 h-6 text-brand-blue" data-id="element-391" />
  }, {
    title: 'Door Glass Replacement',
    copy: 'Car door glass replacement and repair for shattered or damaged door windows on most makes and models.',
    icon: <DoorOpen className="w-6 h-6 text-brand-blue" data-id="element-392" />
  }, {
    title: 'Rear Window Replacement',
    copy: 'Replacement for shattered or damaged rear vehicle glass, back windows and truck rear windows.',
    icon: <ShieldAlert className="w-6 h-6 text-brand-blue" data-id="element-393" />
  }, {
    title: 'Truck, Semi & Fleet Glass',
    copy: 'Truck windshield repair, semi truck glass, commercial truck glass and fleet account service options.',
    icon: <Truck className="w-6 h-6 text-brand-blue" data-id="element-394" />
  }];
  return <section className="py-16 lg:py-24 bg-white" data-id="element-395">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-396">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-397">
          <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-6" data-id="element-398">
            Complete Auto Glass Repair & Replacement
          </h2>
          <p className="text-lg text-slate-600" data-id="element-399">
            From cracked windshields to shattered side windows, Kosin's Glass
            repairs and replaces auto glass for domestic and foreign vehicles
            throughout Southeast Michigan.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12" data-id="element-400">
          {services.map((service, index) => <div key={index} className="bg-slate-50 rounded-2xl p-8 border border-slate-100 hover:shadow-lg hover:shadow-slate-200/50 transition-all duration-300 group scroll-fade-up" style={{
          animationDelay: `${index * 0.08}s`
        }} data-id="element-401">
              <div className="w-14 h-14 bg-brand-light rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-402">
                {service.icon}
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-403">
                {service.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-404">{service.copy}</p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-405">
          <a href="#quote" className="inline-flex items-center justify-center bg-brand-blue hover:bg-brand-hover text-white font-bold text-lg py-4 px-8 rounded-xl transition-colors shadow-lg shadow-brand-blue/20" data-id="element-406">
            Get a Free Auto Glass Estimate
          </a>
        </div>
      </div>
    </section>;
}